"use strict";
const purchaseOrderRow = require('./purchaseOrderRow');
const emcs = require('../../interfaces/transportOrder/emcs');
module.exports = { ...purchaseOrderRow, ...emcs };
